export default __webpack_public_path__ + "static/media/digital-bean.8a2e1063.jpg";